/**
 * Created by Jiu Chen on 12/03/2018.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, forkJoin } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

import { EntityTypeActionTypes } from '../actions/entity-type.actions';
import { EntityTypeService } from '@tamalelibs/services/entity-type.service';
import { EntityType } from '@tamalelibs/models/entity-type.model';

@Injectable()
export class EntityTypeEffects {

    constructor(
        private _actions$: Actions,
        private _entityTypeService: EntityTypeService,
    ) { }

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EntityTypeActionTypes.INITIALIZE),
        switchMap(() => {
            const observableArray = [];
            observableArray.push(this._entityTypeService.getAvailableList());
            observableArray.push(this._entityTypeService.getFullList());
            observableArray.push(this._entityTypeService.getDefaultEntityType());

            return forkJoin(observableArray).pipe(
                map((responses: any) => {
                    const availableEntityTypeList = responses[0]['entity-type-list'].map(item => new EntityType(item.id, item.name));
                    const fullEntityTypeList = responses[1]['entity-type-list'].map(item => new EntityType(item.id, item.name));
                    const defaultEntityType = new EntityType(responses[2].id, responses[2].name);

                    return {
                        type: EntityTypeActionTypes.INITIALIZE_SUCCESS,
                        payload: {
                            available: availableEntityTypeList,
                            full: fullEntityTypeList,
                            default: defaultEntityType
                        }
                    };
                })
            );
        })
    ));
}
